/**
 * TutorList — desktop table listing tutors with status Badge.
 *
 * Props:
 *   tutors        {Array}   list of tutor objects
 *   selectedId    {number|null}
 *   onSelect      {(tutor: Object) => void}
 *   loading       {boolean}
 *   error         {string|null}
 */

import Badge from '../ui/Badge';
import {
  PROFILE_STATUS_LABELS,
  PROFILE_STATUS_COLORS,
} from '../../constants/statusLabels';

const TutorList = ({ tutors = [], selectedId, onSelect, loading, error }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-40">
        <span className="text-gray-400 font-montserrat text-sm">Chargement…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-40">
        <span className="text-red-600 font-montserrat text-sm">{error}</span>
      </div>
    );
  }

  if (!tutors.length) {
    return (
      <div className="flex items-center justify-center h-40">
        <span className="text-gray-400 font-montserrat text-sm">
          Aucun répétiteur dans cette catégorie.
        </span>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200">
      <table className="w-full text-sm font-montserrat">
        <thead>
          <tr className="bg-gray-50 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">
            <th className="px-4 py-3">Nom</th>
            <th className="px-4 py-3">Email</th>
            <th className="px-4 py-3">Spécialisation</th>
            <th className="px-4 py-3">Statut</th>
            <th className="px-4 py-3">Inscrit le</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {tutors.map((tutor) => {
            const isSelected = tutor.id === selectedId;
            const user = tutor.user ?? {};
            const createdAt = tutor.created_at
              ? new Date(tutor.created_at).toLocaleDateString('fr-FR')
              : '—';

            return (
              <tr
                key={tutor.id}
                onClick={() => onSelect(tutor)}
                className={[
                  'cursor-pointer transition-colors',
                  isSelected
                    ? 'bg-[#EAF4FB]'
                    : 'hover:bg-gray-50',
                ].join(' ')}
              >
                <td className="px-4 py-3 font-medium text-[#17386E]">
                  {user.first_name ?? ''} {user.last_name ?? ''}
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {user.email ?? '—'}
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {tutor.specialization ?? '—'}
                </td>
                <td className="px-4 py-3">
                  <Badge
                    status={tutor.status}
                    labels={PROFILE_STATUS_LABELS}
                    colors={PROFILE_STATUS_COLORS}
                  />
                </td>
                <td className="px-4 py-3 text-gray-500">{createdAt}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TutorList;
